/**
 * SendGrid Pricing
 */
export const EI_PLANS = {
  free: {
    startsAt: '$0/mo',
    name: 'Free',
    subHead:
      'Try it out! Integrate fast and explore features with 100 emails/day forever.',
    packages: {
      default: {
        rate: 0,
        overage: 0,
        volume: 2000,
        name: 'Free',
        ease: 0,
        id: 'sg.ei.free-100.v1',
        allowedAddons: {
          ip: false,
          ease: false,
        },
      },
    },
  },

  essentials: {
    startsAt: 19.95,
    name: 'Essentials',
    subHead: 'Empower your business with foundational email features.',
    packages: {
      '40k': {
        rate: 19.95,
        overage: 0.001,
        volume: 50000,
        volumeBreakpoint: 55000,
        name: 'Essentials 50K',
        ease: 5,
        easeIncluded: 3,
        id: 'sg.ei.essentials-40k.v2',
        allowedAddons: {
          ip: false,
          ease: true,
        },
      },
      '100k': {
        rate: 34.95,
        overage: 0.00075,
        volume: 100000,
        name: 'Essentials 100K',
        ease: 12,
        easeIncluded: 3,
        id: 'sg.ei.essentials-100k.v2',
        allowedAddons: {
          ip: false,
          ease: true,
        },
      },
    },
  },

  pro: {
    startsAt: 89.95,
    name: 'Pro',
    subHead: 'Take ownership of your sending to maximize your email delivery.',
    packages: {
      '100k': {
        rate: 89.95,
        overage: 0.00085,
        volume: 100000,
        volumeBreakpoint: 241176,
        name: 'Pro 100K',
        ease: 12,
        easeIncluded: 7,
        id: 'sg.ei.pro-100k.v2',
        allowedAddons: {
          ip: true,
          ease: true,
        },
      },
      '300k': {
        rate: 249,
        overage: 0.0005,
        volume: 300000,
        volumeBreakpoint: 700000,
        name: 'Pro 300K',
        ease: 40,
        easeIncluded: 7,
        id: 'sg.ei.pro-300k.v2',
        allowedAddons: {
          ip: true,
          ease: true,
        },
      },
      '700k': {
        rate: 449,
        overage: 0.00045,
        volume: 700000,
        volumeBreakpoint: 1366667,
        name: 'Pro 700K',
        ease: 95,
        easeIncluded: 7,
        id: 'sg.ei.pro-700k.v2',
        allowedAddons: {
          ip: true,
          ease: true,
        },
      },
      '1500k': {
        rate: 749,
        overage: 0.00045,
        volume: 1500000,
        name: 'Pro 1.5M',
        ease: 175,
        easeIncluded: 7,
        id: 'sg.ei.pro-1p5m.v2',
        allowedAddons: {
          ip: true,
          ease: true,
        },
      },
      // '2500k': {
      //   rate: 999,
      //   overage: 0.00045,
      //   volume: 2500000,
      //   name: 'Pro 2.5M',
      //   ease: 175,
      //   easeIncluded: 7,
      //   id: 'sg.ei.pro-2p5m.v1',
      //   allowedAddons: {
      //     ip: true,
      //     ease: true,
      //   },
      // },
    },
  },

  premier: {
    startsAt: 'Custom Pricing',
    name: 'Premier',
    subHead: 'Amplify your email program with extra support from our team.',
    packages: false,
  },
};

export const MC_PLANS = {
  free: {
    startsAt: '$0/mo',
    name: 'Free',
    subHead:
      'Try it out! Store up to 2,000 contacts and send up to 6,000 emails/mo.',
    packages: {
      default: {
        rate: 0,
        volume: 6000,
        contacts: 2000,
        name: 'Free',
        id: 'sg.mc.free.v1',
        allowedAddons: {
          ip: false,
          ease: false,
        },
      },
    },
  },

  basic: {
    startsAt: 15.0,
    name: 'Basic',
    subHead: 'Design, send, and measure email marketing campaigns with ease.',
    packages: {
      '5k': {
        rate: 15.0,
        volume: 15000,
        volumeBreakpoint: 17500,
        contacts: 5000,
        contactsBreakpoint: 7500,
        name: 'Basic 5K',
        id: 'sg.mc.basic-5k.v1',
        allowedAddons: {
          ip: false,
          ease: false,
        },
      },
      '10k': {
        rate: 25.0,
        volume: 30000,
        volumeBreakpoint: 38333,
        contacts: 10000,
        contactsBreakpoint: 18333,
        name: 'Basic 10K',
        id: 'sg.mc.basic-10k.v1',
        allowedAddons: {
          ip: false,
          ease: false,
        },
      },
      '20k': {
        rate: 50.0,
        volume: 60000,
        volumeBreakpoint: 83333,
        contacts: 20000,
        contactsBreakpoint: 43333,
        name: 'Basic 20K',
        id: 'sg.mc.basic-20k.v1',
        allowedAddons: {
          ip: false,
          ease: false,
        },
      },
      '50k': {
        rate: 120.0,
        volume: 150000,
        volumeBreakpoint: 178571,
        contacts: 50000,
        contactsBreakpoint: 78571,
        name: 'Basic 50K',
        id: 'sg.mc.basic-50k.v1',
        allowedAddons: {
          ip: false,
          ease: false,
        },
      },
      '100k': {
        rate: 200.0,
        volume: 300000,
        contacts: 100000,
        name: 'Basic 100K',
        id: 'sg.mc.basic-100k.v1',
        allowedAddons: {
          ip: false,
          ease: false,
        },
      },
    },
  },

  advanced: {
    startsAt: 60.0,
    name: 'Advanced',
    subHead:
      'Level up with powerful features to advance your email marketing program.',
    packages: {
      '10k': {
        rate: 60.0,
        volume: 50000,
        volumeBreakpoint: 55333,
        contacts: 10000,
        contactsBreakpoint: 15333,
        name: 'Advanced 10K',
        id: 'sg.mc.advanced-10k.v1',
        allowedAddons: {
          ip: true,
          ease: false,
        },
      },
      '20k': {
        rate: 100.0,
        volume: 100000,
        volumeBreakpoint: 125000,
        contacts: 20000,
        contactsBreakpoint: 45000,
        name: 'Advanced 20K',
        id: 'sg.mc.advanced-20k.v1',
        allowedAddons: {
          ip: true,
          ease: false,
        },
      },
      '50k': {
        rate: 250.0,
        volume: 250000,
        volumeBreakpoint: 283333,
        contacts: 50000,
        contactsBreakpoint: 83333,
        name: 'Advanced 50K',
        id: 'sg.mc.advanced-50k.v1',
        allowedAddons: {
          ip: true,
          ease: false,
        },
      },
      '100k': {
        rate: 450.0,
        volume: 500000,
        volumeBreakpoint: 590000,
        contacts: 100000,
        contactsBreakpoint: 190000,
        name: 'Advanced 100K',
        id: 'sg.mc.advanced-100k.v1',
        allowedAddons: {
          ip: true,
          ease: false,
        },
      },
      '200k': {
        rate: 900.0,
        volume: 1000000,
        contacts: 200000,
        name: 'Advanced 200K',
        id: 'sg.mc.advanced-200k.v1',
        allowedAddons: {
          ip: true,
          ease: false,
        },
      },
    },
  },
};
